"use strict";
/*
 * Created on 10. 1. 2019
 *
 * Copyright (c) 2019 Etnetera, a.s. All rights reserved.
 * Intended for internal use only.
 * http://www.etnetera.cz
 */

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var DataObjectConverter_1 = require("../../../core/conversions/DataObjectConverter");
/**
 * Converter for {@link PromotionAppConfig}.
 *
 * @author Radek Beran
 */


var PromotionAppConfigConverter =
/*#__PURE__*/
function (_DataObjectConverter_) {
  _inherits(PromotionAppConfigConverter, _DataObjectConverter_);

  function PromotionAppConfigConverter() {
    _classCallCheck(this, PromotionAppConfigConverter);

    return _possibleConstructorReturn(this, _getPrototypeOf(PromotionAppConfigConverter).apply(this, arguments));
  }

  return PromotionAppConfigConverter;
}(DataObjectConverter_1.DataObjectConverter);

exports.PromotionAppConfigConverter = PromotionAppConfigConverter;